import { render, staticRenderFns } from "./BrbInput.vue?vue&type=template&id=2171f808&"
import script from "./BrbInput.vue?vue&type=script&lang=js&"
export * from "./BrbInput.vue?vue&type=script&lang=js&"
import style0 from "./BrbInput.vue?vue&type=style&index=0&id=2171f808&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2171f808')) {
      api.createRecord('2171f808', component.options)
    } else {
      api.reload('2171f808', component.options)
    }
    module.hot.accept("./BrbInput.vue?vue&type=template&id=2171f808&", function () {
      api.rerender('2171f808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbInput.vue"
export default component.exports